export class Video {
    constructor(el) {
        this.el = el;
        this.playButton = this.el.querySelector(".js-video-play");
        this.video = this.el.querySelector(".js-video-node");

        this.playButton?.addEventListener("click", () => {
            this.playButton.classList.add("hide");
            this.video?.play();
            this.video && (this.video.controls = true);
        });
    }
}

document.querySelectorAll(".js-video").forEach((el) => new Video(el));
